import {ITriviaContestsHistory} from "apps/BWW_TRIVIA/modules/reducers/contests_history_trivia";
import {createAction} from "redux-act";


/**
 * Actions to fetch history contests
 * UAT example
 * https://uat-bww-play.fanhubmedia.com/trivia/json/contests-history.json
 */
export const fetchContestsHistory = createAction();
export const fetchContestsHistorySuccess = createAction<ITriviaContestsHistory>();
export const fetchContestsHistoryFailed = createAction<Error>();
